import React, { useContext, useEffect, useState, useRef } from 'react';
import brushImg from '../../../assets/images/brush.png';
import { notification, Switch } from 'antd';
import { axiosInstance } from '../config';
import Loader from '../../common/Loader';
import { ServicesContext } from '../../Reusable/ServiceContextmain';
import { Helmet } from 'react-helmet';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

dayjs.extend(isSameOrAfter);

const serviceAreas = [
  { name: 'Loughborough', lat: 52.7726, lng: -1.2073 },
  { name: 'Nottingham', lat: 52.9548, lng: -1.1581 },
  { name: 'Coventry', lat: 52.4068, lng: -1.5197 },
  { name: 'Corby', lat: 52.4939, lng: -0.6941 },
  { name: 'Kettering', lat: 52.3931, lng: -0.7231 },
  { name: 'Northampton', lat: 52.2405, lng: -0.9027 },
  { name: 'Rugby', lat: 52.3709, lng: -1.2646 },
];

const officeLocation = { lat: 52.6356, lng: -1.1501 };

const greenIcon = L.divIcon({
  className: 'custom-marker',
  html: `<div style="position:relative;width:30px;height:40px;">
    <svg viewBox="0 0 24 36" width="30" height="40" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 0C5.4 0 0 5.4 0 12c0 9 12 24 12 24s12-15 12-24C24 5.4 18.6 0 12 0z" fill="#2e7d32"/>
      <circle cx="12" cy="11" r="5" fill="#fff"/>
    </svg>
  </div>`,
  iconSize: [30, 40],
  iconAnchor: [15, 40],
  popupAnchor: [0, -35],
});

const redIcon = L.divIcon({
  className: 'custom-marker',
  html: `<div style="position:relative;width:36px;height:46px;">
    <svg viewBox="0 0 24 36" width="36" height="46" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 0C5.4 0 0 5.4 0 12c0 9 12 24 12 24s12-15 12-24C24 5.4 18.6 0 12 0z" fill="#e53935"/>
      <circle cx="12" cy="11" r="5" fill="#fff"/>
    </svg>
  </div>`,
  iconSize: [36, 46],
  iconAnchor: [18, 46],
  popupAnchor: [0, -41],
});

const ContactIndex = () => {
  const { services, loading, error } = useContext(ServicesContext);
  const [data, setdata] = useState([]);
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markersRef = useRef({});
  const [activeLocation, setActiveLocation] = useState(null);

  const handleLocationClick = (area) => {
    setActiveLocation(area.name);
    if (mapInstanceRef.current) {
      mapInstanceRef.current.flyTo([area.lat, area.lng], 11, { duration: 1.5 });
      mapInstanceRef.current.invalidateSize();
    }
  };

  const handleShowAll = () => {
    setActiveLocation(null);
    if (mapInstanceRef.current) {
      mapInstanceRef.current.flyTo(
        [officeLocation.lat, officeLocation.lng],
        9,
        { duration: 1.5 }
      );
      mapInstanceRef.current.invalidateSize();
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    axiosInstance
      .get(`settings`)
      .then((res) => {
        setdata(res?.data?.settings);
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!mapRef.current || mapInstanceRef.current) return;

    const map = L.map(mapRef.current).setView(
      [officeLocation.lat, officeLocation.lng],
      9
    );

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
    }).addTo(map);

    const officeMarker = L.marker([officeLocation.lat, officeLocation.lng], {
      icon: greenIcon,
    })
      .addTo(map)
      .bindPopup(
        '<strong>Precision Contract Cleaning</strong><br/>4 Rivers Street, Leicester, LE3 5RX'
      );
    markersRef.current['office'] = officeMarker;

    serviceAreas.forEach((area) => {
      const marker = L.marker([area.lat, area.lng], { icon: greenIcon })
        .addTo(map)
        .bindPopup(`<strong>${area.name}</strong>`);
      markersRef.current[area.name] = marker;
    });

    mapInstanceRef.current = map;
  }, []);

  useEffect(() => {
    const markers = markersRef.current;
    if (!mapInstanceRef.current) return;

    Object.keys(markers).forEach((key) => {
      const marker = markers[key];
      const isActive = key === activeLocation;
      marker.setIcon(isActive ? redIcon : greenIcon);
      if (isActive) {
        marker.openPopup();
      } else {
        marker.closePopup();
      }
    });
  }, [activeLocation]);

  const date = new Date();
  const [isTenderQuery, setIsTenderQuery] = useState(false);
  const minDateTime = date.toISOString().slice(0, 16);
  const [Loading, setLoading] = useState(false);

  const [formdata, setformdata] = useState({
    name: '',
    email: '',
    phone: '',
    datetime: '',
    servicename: '',
    message: '',
    noOfProperties: '',
  });

  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    let error = '';
    switch (name) {
      case 'name':
        if (!value) error = 'Name is required.';
        break;
      case 'email':
        if (!value) {
          error = 'Email is required.';
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          error = 'Email address is invalid.';
        }
        break;
      case 'phone':
        if (!value) {
          error = 'Phone number is required.';
        } else if (value.length < 10) {
          errors.phone = 'Please enter a valid phone number.';
        }
        break;
      case 'datetime':
        if (!value) {
          error = 'Date and time are required.';
        } else if (dayjs(value).isBefore(dayjs())) {
          error = 'Please select a future date and time.';
        }
        break;
      case 'servicename':
        if (!value || value === 'Your-Service') {
          error = 'Please select a service.';
        }
        break;
      case 'message':
        if (!value) error = 'Message is required.';
        break;
      case 'noOfProperties':
        if (isTenderQuery && !value) {
          error = 'No. of Properties is required.';
        }
        break;
      default:
        break;
    }
    return error;
  };

  const HandleInquiry = async (e) => {
    e.preventDefault();

    const validationErrors = {};
    for (const field in formdata) {
      const error = validateField(field, formdata[field]);
      if (error) validationErrors[field] = error;
    }
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setLoading(true);
      try {
        const EnquiryData = {
          ...formdata,
          tendercontract: isTenderQuery ? 1 : 0,
        };

        const response = await axiosInstance.post(`/inquiry/add`, EnquiryData);
        if (response?.data?.success) {
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-20">
                  <i
                    className="bi bi-check2-circle text-success"
                    style={{ fontSize: '20px' }}
                  ></i>
                </div>
                <div>Enquiry Submitted Successfully</div>
              </div>
            ),
            description: 'You can expect call in 24 hours from our team.',
          });
          setLoading(false);
          setformdata({
            name: '',
            email: '',
            phone: '',
            datetime: '',
            servicename: '',
            message: '',
            noOfProperties: '',
          });
        } else {
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-20">
                  <i
                    className="bi bi-exclamation-circle-fill text-danger"
                    style={{ fontSize: '20px' }}
                  ></i>
                </div>
                <div>Opps! Something went wrong.</div>
              </div>
            ),
            description: 'Try Again !',
          });
          setformdata({
            name: '',
            email: '',
            phone: '',
            datetime: '',
            servicename: '',
            message: '',
            noOfProperties: '',
          });
        }
      } catch (e) {
        setLoading(false);
      }
    }
  };

  const handleChange = (e) => {
    const { name } = e.target;
    let value = e.target.value;

    if (name === 'phone') {
      value = value.replace(/\D/g, '');
    }
    // Update formdata first
    const updatedFormData = { ...formdata, [name]: value };
    setformdata(updatedFormData);
    // Validate the field
    const error = validateField(name, value);
    // Update errors based on validation
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const handleSwitchChange = (checked) => {
    setIsTenderQuery(checked); // Update the state based on the switch value
  };
  const disabledDate = (current) => {
    return current && current < dayjs().startOf('day');
  };

  return (
    <div>
      <Helmet>
        <title>{data[2]?.metatitle || 'Precision Contract Cleaning'}</title>
        <meta
          name="description"
          content={data[2]?.metadescription || 'Precision Contract Cleaning'}
        />
        <meta
          name="keywords"
          content={data[2]?.metakeywords || 'Precision Contract Cleaning'}
        />
      </Helmet>
      {Loading && <Loader />}
      <div className="rs-contact contact-style3 pt-120 pb-120 md-pt-80 md-pb-80">
        <div className="container custom2">
          <div className="row">
            <div className="col-lg-5 md-mb-50">
              <div className="rs-contact-box">
                <div className="sec-title2 mb-40">
                  <div className="brush-content mb-20">
                    <img src={brushImg} alt="" />
                    <span className="sub-text">Contact Us</span>
                  </div>
                  <h2 className="title small pb-15">Get In Touch</h2>
                  <div className="desc">
                    We’re here to assist you with all your cleaning needs. Reach
                    out to us for inquiries, quotes, or any questions—our team
                    is ready to help!
                  </div>
                </div>
                <div className="address-item mb-30">
                  <div className="address-icon">
                    <i className="bi bi-telephone-inbound"></i>
                  </div>
                  <div className="address-content">
                    <span className="label">Phone:</span>
                    <a href="tel:01162102688" className="des d-block">
                      01162102688
                    </a>
                    <a href="tel:07380851496" className="des d-block">
                      07380851496
                    </a>
                  </div>
                </div>
                <div className="address-item mb-30">
                  <div className="address-icon">
                    <i className="bi bi-envelope-open"></i>
                  </div>
                  <div className="address-content">
                    <span className="label">Mail Us:</span>
                    <a
                      href="mailto:info@precisioncontractservices.com"
                      className="des"
                    >
                      info@precisioncontractservices.com
                    </a>
                  </div>
                </div>
                <div className="address-item mb-30">
                  <div className="address-icon">
                    <i className="bi bi-geo-alt"></i>
                  </div>
                  <div className="address-content">
                    <span className="label">Visit Us:</span>
                    <span className="des">
                      4 Rivers Street, Leicester, England, LE3 5RX
                    </span>
                  </div>
                </div>
                <div className="address-item mb-30">
                  <div className="address-icon">
                    <i className="bi bi-clock"></i>
                  </div>
                  <div className="address-content">
                    <span className="label">Opening Hours:</span>
                    <span className="des d-block">
                      Mon-Fri: 9:00 AM – 6:00 PM
                    </span>
                    <span className="des d-block">
                      Saturday: 10:00 AM – 2:00 PM
                    </span>
                    <span className="des d-block">Sunday: Closed</span>
                  </div>
                </div>
                <div className="address-item mb-30">
                  <div className="address-icon">
                    <i className="bi bi-share"></i>
                  </div>
                  <div className="address-content">
                    <span className="label">Follow Us:</span>
                    <div
                      className="social-icons"
                      style={{ display: 'flex', gap: '15px', marginTop: '5px' }}
                    >
                      <a
                        href="https://www.facebook.com/PrecisionContractCleaningServices"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i
                          className="bi bi-facebook"
                          style={{ fontSize: '25px' }}
                        ></i>
                      </a>
                      <a
                        href="https://www.instagram.com/precisioncontractcleaning/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i
                          className="bi bi-instagram"
                          style={{ fontSize: '25px' }}
                        ></i>
                      </a>
                      <span>
                        <i
                          className="bi bi-linkedin"
                          style={{ fontSize: '25px' }}
                        ></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-7 pl-50 md-pl-15">
              <div className="contact-drop-line">
                <div className="heading-inner-title mb-30">
                  <h2 className="title">Get Clean Today!</h2>
                </div>
                <div id="form-messages" />
                <form id="contact-form" onSubmit={HandleInquiry}>
                  <fieldset>
                    <div className="row">
                      <div className="col-lg-6 mb-30 col-md-6 col-sm-6">
                        <input
                          className="from-control"
                          type="text"
                          id="name"
                          name="name"
                          placeholder="Name"
                          value={formdata.name}
                          onChange={handleChange}
                        />
                        {errors.name && (
                          <span
                            className="text-danger ps-3"
                            style={{ fontSize: '14px' }}
                          >
                            * {errors.name}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-6 mb-30 col-md-6 col-sm-6">
                        <input
                          className="from-control"
                          type="text"
                          id="email"
                          name="email"
                          placeholder="E-Mail"
                          value={formdata.email}
                          onChange={handleChange}
                        />
                        {errors.email && (
                          <span
                            className="text-danger ps-3"
                            style={{ fontSize: '14px' }}
                          >
                            * {errors.email}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-6 mb-30 col-md-6 col-sm-6">
                        <input
                          className="from-control"
                          type="tel"
                          id="phone"
                          name="phone"
                          placeholder="Phone Number"
                          value={formdata.phone}
                          onChange={handleChange}
                          maxLength={15}
                        />
                        {errors.phone && (
                          <span
                            className="text-danger ps-3"
                            style={{ fontSize: '14px' }}
                          >
                            * {errors.phone}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-6 mb-30 col-md-6 col-sm-6">
                        <DatePicker
                          showTime
                          format="DD/MM/YYYY hh:mm A"
                          placeholder="dd/mm/yyyy --:-- --"
                          disabledDate={(current) =>
                            current && current < dayjs().startOf('day')
                          }
                          style={{
                            width: '100%',
                            height: '54px',
                          }}
                          value={
                            formdata.datetime ? dayjs(formdata.datetime) : null
                          }
                          onChange={(date) => {
                            // Ignore clearing action
                            if (!date) {
                              return;
                            }

                            setformdata((prev) => ({
                              ...prev,
                              datetime: date.format('YYYY-MM-DD HH:mm:ss'),
                            }));

                            setErrors((prev) => ({
                              ...prev,
                              datetime: '',
                            }));
                          }}
                          allowClear={false}
                        />{' '}
                        {errors.datetime && (
                          <span
                            className="text-danger ps-3"
                            style={{ fontSize: '14px' }}
                          >
                            * {errors.datetime}
                          </span>
                        )}
                      </div>
                      <div className="col-12 mb-30">
                        <select
                          name="servicename"
                          className="wpcf7-form-control wpcf7-select"
                          value={formdata.servicename}
                          onChange={handleChange}
                        >
                          <option value="">Select Service</option>
                          {Array.isArray(services) &&
                            services.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                        </select>
                        {errors.servicename && (
                          <span
                            className="text-danger ps-3"
                            style={{ fontSize: '14px' }}
                          >
                            * {errors.servicename}
                          </span>
                        )}
                      </div>
                      <div className="d-flex justify-content-between">
                        <h6 className="form-Query mb-3">
                          Is This Query For Tender Contract?
                        </h6>
                        <Switch
                          defaultChecked={false}
                          onChange={handleSwitchChange}
                        />
                      </div>
                      {isTenderQuery && (
                        <div className="col-lg-12 mb-3">
                          <input
                            type="number"
                            min={1}
                            className={`from-control ${errors.noOfProperties ? 'error' : ''}`}
                            id="noOfProperties"
                            name="noOfProperties"
                            placeholder="No. of Properties"
                            value={formdata.noOfProperties}
                            onChange={handleChange}
                          />

                          {errors.noOfProperties && (
                            <span className="text-danger ps-2">
                              * {errors.noOfProperties}
                            </span>
                          )}
                        </div>
                      )}
                      <div className="col-lg-12 mb-30">
                        <textarea
                          className="from-control"
                          id="message"
                          name="message"
                          placeholder="Your Message"
                          value={formdata.message}
                          onChange={handleChange}
                        />
                        {errors.message && (
                          <span
                            className="text-danger ps-3"
                            style={{ fontSize: '14px' }}
                          >
                            * {errors.message}
                          </span>
                        )}
                      </div>

                      <div className="btn-part">
                        <div className="form-group mb-0">
                          <p className="submit-btn submit-btn3">
                            <input type="submit" defaultValue="Submit Now" />
                          </p>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
          <div className="rs-service-areas pt-120 md-pt-80">
            <div className="container">
              <div className="sec-title text-center mb-50">
                <h2 className="title mb-3">Our Service Areas</h2>
                <p className="desc">
                  We provide contract cleaning services across Leicester and
                  surrounding areas.
                </p>
              </div>
              <div
                className={`service-areas-wrapper ${activeLocation ? 'service-expanded' : ''}`}
              >
                <div className="service-areas-sidebar">
                  <button
                    className={`show-all-btn ${activeLocation === null ? 'active' : ''}`}
                    onClick={handleShowAll}
                  >
                    <i className="bi bi-geo-alt-fill"></i>
                    <span>Show All Locations</span>
                  </button>
                  <div className="locations-list">
                    <div
                      className={`location-item office-item ${activeLocation === 'office' ? 'active' : ''}`}
                      onClick={() => {
                        setActiveLocation('office');
                        if (mapInstanceRef.current) {
                          mapInstanceRef.current.flyTo(
                            [officeLocation.lat, officeLocation.lng],
                            14,
                            { duration: 1.5 }
                          );
                          mapInstanceRef.current.invalidateSize();
                        }
                      }}
                    >
                      <i className="bi bi-building"></i>
                      <span>Leicester</span>
                    </div>
                    {serviceAreas.map((area, index) => (
                      <div
                        key={index}
                        className={`location-item ${activeLocation === area.name ? 'active' : ''}`}
                        onClick={() => handleLocationClick(area)}
                      >
                        <i className="bi bi-geo-alt-fill"></i>
                        <span>{area.name}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="service-areas-map">
                  <div
                    ref={mapRef}
                    style={{ width: '100%', height: '100%', zIndex: 1 }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactIndex;
